export default __webpack_public_path__ + "static/media/toolTipLeft.7fbfd94c.svg";